/* eslint-disable no-alert */
import { Box, Button, Divider, Tab, Tabs, Typography } from "@mui/material";
import MainLayout from "layout/MainLayout";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import feedbackService from "services/feedback-service";
import PromptModal from "modals/miscellaneous/PromptModal";
import DataPrivacyPolicy from "./DataPrivacyPolicy";
import PersonalInfo from "./PersonalInfo";
import SurveyForm from "./SurveyForm";
import CitizenCharter from "./CitizenCharter";
import DepedLogo from "../../../assets/images/deped_logo.png";
import KagawaranLogo from "../../../assets/images/kagawaran.png";
import TranparencyLogo from "../../../assets/images/transparency_logo.png";

function Feedback() {
  const navigate = useNavigate();

  const [questions, setQuestions] = useState([]);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFilled, setIsFilled] = useState(false);

  const [selectedTab, setSelectedTab] = useState(0);
  const [openModal, setOpenModal] = useState(false);

  const [feedbackData, setFeedbackData] = useState({
    formResponse: {
      consent: "",
    },
    submitter: {
      name: "",
      email: "",
      // ageId: "",
      specificAge: "",
      clientTypeId: "",
      sex: "",
    },
    citizencharter: {
      awareCC: "",
      seeCC: "",
      useCC: "",
    },
    serviceFeedback: {
      startTime: "",
      serviceId: "",
      serviceKindId: "",
      otherService: "",
      designationId: "",
      levelId: "",
      officeId: "",
      overallComment: "",
    },
    data: [],
  });

  // const updateDetails = (newDetails) => {
  //   setFeedbackData((prevData) => ({
  //     ...prevData,
  //     ...newDetails,
  //   }));
  // };

  const handleConsentUpdate = (updatedData) => {
    setFeedbackData((prevData) => ({
      ...prevData,
      formResponse: {
        ...prevData.formResponse,
        consent: updatedData.consent,
      },
      serviceFeedback: {
        ...prevData.serviceFeedback,
        startTime: updatedData.consent
          ? dayjs(new Date().toISOString()).format("YYYY-MM-DDTHH:mm:ss")
          : null,
      },
    }));
  };

  const handleCCUpdate = (updatedCC) => {
    setFeedbackData((prevData) => ({
      ...prevData,
      citizencharter: {
        ...prevData.citizencharter,
        awareCC: updatedCC.awareCC,
        seeCC: updatedCC.seeCC,
        useCC: updatedCC.useCC,
      },
    }));
  };

  const handleDataUpdate = (updatedData) => {
    setFeedbackData((prevData) => ({
      ...prevData,
      submitter: {
        name: updatedData.name,
        email: updatedData.email,
        specAge: updatedData.specAge,
        clientTypeId: updatedData.clientTypeId,
        sex: updatedData.sex,
      },
      serviceFeedback: {
        startTime: updatedData.startTime,
        serviceId: updatedData.serviceId,
        serviceKindId: updatedData.serviceKindId,
        designationId: updatedData.designationId,
        levelId: updatedData.levelId,
        otherService: updatedData.otherService,
        officeId: updatedData.officeId,
        overallComment: updatedData.overallComment,
      },
      data: feedbackData.data,
    }));
  };

  const handleFormUpdate = (updatedData) => {
    setFeedbackData((prevData) => ({
      ...prevData,
      serviceFeedback: {
        ...prevData.serviceFeedback,
        overallComment: updatedData.overallComment,
      },
      data: updatedData.data.map((item) => ({
        ...item,
      })),
    }));
  };

  const handleSubmit = () => {
    feedbackService
      .feedbackSubmit(feedbackData)
      .then(() => {
        setFeedbackData({
          formResponse: {
            consent: "",
          },
          submitter: {
            name: "",
            email: "",
            specAge: "",
            clientTypeId: "",
            sex: "",
          },
          citizencharter: {
            awareCC: "",
            seeCC: "",
            useCC: "",
          },
          serviceFeedback: {
            serviceId: "",
            designationId: "",
            levelId: "",
            serviceKindId: "",
            officeId: "",
            overallComment: "",
          },
          data: [],
        });
        setSelectedTab(0);
        setOpenModal(true);
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  const handleNext = (tabNum) => {
    setSelectedTab(tabNum === 3 ? 3 : tabNum + 1);
  };

  const handlePrev = (tabNum) => {
    setSelectedTab(tabNum === 0 ? 0 : tabNum - 1);
  };

  const handleNavigate = () => {
    navigate("/");
  };

  const handleGetAll = () => {
    setLoading(true);
    feedbackService
      .getAllQuestions()
      .then((e) => {
        setQuestions(e);
      })
      .catch((err) => {
        setError(err.message || "An error occurred");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetAll();
  }, []);

  useEffect(() => {
    const { name, email, ...otherSubmitterValues } = feedbackData.submitter;

    const {
      overallComment,
      otherService,
      serviceKindId,
      designationId,
      levelId,
      ...otherServiceValues
    } = feedbackData.serviceFeedback;

    let otherValues = {};

    if (selectedTab === 1) {
      otherValues = {
        ...otherSubmitterValues,
        ...otherServiceValues,
      };
    } else if (selectedTab === 2) {
      otherValues = {
        ...feedbackData.citizencharter,
        ...otherSubmitterValues,
        ...otherServiceValues,
      };
    }

    const areOtherValuesFilled = Object.values(otherValues).every(
      (value) => !!value
    );

    setIsFilled(!areOtherValuesFilled);
  }, [feedbackData]);

  const disable =
    isFilled ||
    Boolean(!questions) ||
    feedbackData?.data?.length !== questions?.length;

  return (
    <MainLayout>
      <Box
        sx={{
          textAlign: "center",
          my: 5,
        }}
      >
        <Box
          onClick={handleNavigate}
          component="img"
          variant="img"
          src={DepedLogo}
          sx={{
            width: { xs: "20%", md: "10%", xl: "10%" },
            // "@media (max-width: 1500px)": {
            //   width: "10%",
            // },
            "@media (min-height: 1080px)": {
              mt: 1,
              width: "15%",
            },
          }}
        />
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "0.5", xl: "1.5rem" },
            "@media (min-height: 1080px)": {
              fontSize: "1.75rem",
            },
            color: "#black",
            mt: 2,
          }}
        >
          CLIENT SATISFACTION MEASUREMENT (CSM) SURVEY
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "70vw",
          "@media (max-height: 1080px)": {
            width: "60vw",
          },
          minWidth: "380px",
          mb: 4,
          backgroundColor: "rgba(255, 255, 255, 1)",
          boxShadow: "3px 2px 20px 3px rgba(65, 65, 65, 0.6)",
          borderRadius: "10px",
          px: 6,
          py: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "1.2rem", md: "2rem", xl: "3rem" },
            fontFamily: "Satisfy",
            textAlign: "center",
            p: 4,
            color: "white",
            mx: -6,
            mt: -2,
            borderRadius: "3px 2.5px 0 0",
            background: "#03787c",
            mb: 1,
            fontWeight: "bold",
            "@media (min-height: 1080px)": {
              fontSize: "2.5rem",
            },
          }}
        >
          We Would Like To Hear From You !
        </Typography>
        <Tabs
          value={selectedTab}
          indicatorColor="primary"
          textColor="secondary"
        >
          <Tab
            label="Consent"
            sx={{
              margin: "0 20px 0px 0px",
              fontWeight: "900",
              fontFamily: "Poppins, sans-serif",
              fontSize: { xs: "0.7rem", sm: "0.8rem", md: "1rem" }, // Adjust sizes for different screens
              color: selectedTab === 0 ? "blue" : "#2e3a3f",
              "&.Mui-selected": {
                color: "blue", // Change color when the tab is selected
              },
            }}
          />
          <Tab
            label="Client Information"
            sx={{
              margin: "0 20px 0px 20px",
              fontWeight: "900",
              fontFamily: "Poppins, sans-serif",
              fontSize: { xs: "0.7rem", sm: "0.8rem", md: "1rem" }, // Adjust sizes for different screens
              color: selectedTab === 1 ? "blue" : "#2e3a3f",
              "&.Mui-selected": {
                color: "blue", // Change color when the tab is selected
              },
            }}
          />
          <Tab
            label="Citizen Charter"
            sx={{
              margin: "0 20px 0px 20px",
              fontWeight: "900",
              fontFamily: "Poppins, sans-serif",
              fontSize: { xs: "0.7rem", sm: "0.8rem", md: "1rem" }, // Adjust sizes for different screens
              color: selectedTab === 2 ? "blue" : "#2e3a3f",
              "&.Mui-selected": {
                color: "blue", // Change color when the tab is selected
              },
            }}
          />
          <Tab
            label="Survey"
            sx={{
              margin: "0 20px 0px 20px",
              fontWeight: "900",
              fontFamily: "Poppins, sans-serif",
              fontSize: { xs: "0.7rem", sm: "0.8rem", md: "1rem" }, // Adjust sizes for different screens
              color: selectedTab === 3 ? "blue" : "#2e3a3f",
              "&.Mui-selected": {
                color: "blue", // Change color when the tab is selected
              },
            }}
          />
        </Tabs>
        <Box
          sx={{
            width: "100%",
            p: { xs: 1, xl: 2 },
            my: "2vh",
            "@media (max-height: 1080px)": {
              my: "5vh",
            },
            backgroundColor: "#FFF",
            boxShadow: "3px 2px 15px 3px rgba(100, 100, 100, 0.8)",
            borderRadius: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              my: 2,
            }}
          >
            {selectedTab === 0 && (
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "0.7rem", md: "1rem", xl: "20px" },
                  fontFamily: "Poppins, sans-serif",
                  color: "#2e3a3f",
                  "@media (min-height: 1080px)": {
                    fontSize: "1.5rem",
                  },
                }}
              >
                DATA PRIVACY POLICY
              </Typography>
            )}
            {selectedTab === 1 && (
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "0.7rem", md: "1rem", xl: "20px" },
                  fontFamily: "Poppins, sans-serif",
                  color: "#2e3a3f",
                  "@media (min-height: 1080px)": {
                    fontSize: "1.5rem",
                  },
                }}
              >
                CLIENT INFORMATION
              </Typography>
            )}
            {selectedTab === 2 && (
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "0.7rem", md: "1rem", xl: "20px" },
                  fontFamily: "Poppins, sans-serif",
                  color: "#2e3a3f",
                  "@media (min-height: 1080px)": {
                    fontSize: "1.5rem",
                  },
                }}
              >
                CITIZEN CHARTER AWARENESS
              </Typography>
            )}
            {selectedTab === 3 && (
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "0.7rem", md: "1rem", xl: "20px" },
                  fontFamily: "Poppins, sans-serif",
                  color: "#2e3a3f",
                  "@media (min-height: 1080px)": {
                    fontSize: "1.5rem",
                  },
                }}
              >
                SATISFACTION SURVEY
              </Typography>
            )}
          </Box>
          <Divider sx={{ backgroundColor: "gray" }} />
          <Box
            role="tabpanel"
            sx={{
              overflowY: "auto",
              width: "100%",
            }}
          >
            {selectedTab === 0 && (
              <DataPrivacyPolicy updateDetails={handleConsentUpdate} />
            )}
            {selectedTab === 1 && (
              <PersonalInfo
                details={feedbackData}
                updateDetails={handleDataUpdate}
                isFilled={isFilled}
              />
            )}
            {selectedTab === 2 && (
              <CitizenCharter
                details={feedbackData}
                updateDetailsCC={handleCCUpdate}
                isFilled={isFilled}
              />
            )}
            {selectedTab === 3 && (
              <SurveyForm
                data={feedbackData.data}
                overall={feedbackData.serviceFeedback}
                onDataUpdate={handleFormUpdate}
                questions={questions}
                error={error}
                loading={loading}
              />
            )}
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            onClick={() => handlePrev(selectedTab)}
            sx={{
              mr: 2,
              mt: { xs: -3, md: 0.2 },
              fontSize: { xs: "0.5rem", md: "0.7rem", xl: "1rem" },
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            }}
          >
            Previous
          </Button>
          {selectedTab === 3 ? (
            <Button
              type="submit"
              onClick={() => handleSubmit("submit")}
              disabled={disable}
              sx={{
                mr: 2,
                mt: { xs: -3, md: 0.2 },
                fontSize: { xs: "0.5rem", md: "0.7rem", xl: "1rem" },
                backgroundColor: disable ? "transparent" : "blue",
                color: "#fff",
                p: "8px 15px",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#2c2966",
                  fontWeight: "bold",
                },
                "@media (min-height: 1080px)": {
                  fontSize: "1rem",
                },
              }}
            >
              Submit
            </Button>
          ) : (
            <Button
              onClick={() => handleNext(selectedTab)}
              disabled={
                (selectedTab === 1 && isFilled) ||
                (selectedTab === 2 && isFilled) ||
                feedbackData.formResponse.consent !== "Agree"
              }
              sx={{
                mr: 2,
                mt: { xs: -3, md: 0.2 },
                fontSize: {
                  xs: "0.5rem",
                  md: "0.7rem",
                  xl: "1rem",
                  "@media (min-height: 1080px)": {
                    fontSize: "1rem",
                  },
                },
              }}
            >
              Next
            </Button>
          )}
        </Box>
        <Box
          sx={{
            mt: { xs: 5, xl: 12 },
            display: "flex",
            // display: "inline-block",
            // width: "80vw",
            // "@media (max-height: 1080px)": {
            //   width: "70vw",
            // },
          }}
        >
          <Box
            sx={{
              display: "inline-block",
              flex: 1,
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "0.5rem", md: "0.7rem", xl: "1rem" },
                "@media (min-height: 1080px)": {
                  fontSize: "1rem",
                },
              }}
            >
              Toclong I-C Imus City, Cavite 4103
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "0.5rem", md: "0.7rem", xl: "1rem" },
                "@media (min-height: 1080px)": {
                  fontSize: "1rem",
                },
              }}
            >
              imus.city@deped.gov.ph
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "0.5rem", md: "0.7rem", xl: "1rem" },
                "@media (min-height: 1080px)": {
                  fontSize: "1rem",
                },
              }}
            >
              depedimuscity.com
            </Typography>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Box
              component="img"
              src={KagawaranLogo}
              mr={2}
              sx={{
                width: "min(10vh, 10vw)", // Ensures the logo is responsive
                height: "min(10vh, 10vw)",
                maxWidth: "15vh", // Prevents excessive scaling
                maxHeight: "15vh",
                "@media (max-width: 1080px) and (min-height: 1920px)": {
                  width: "min(10vh, 10vw)",
                  height: "min(10vh, 10vw)",
                },
                "@media (max-width: 900px) and (min-height: 1600px)": {
                  width: "min(4vh, 4vw)",
                  height: "min(4vh, 4vw)",
                },
              }}
            />
            <Box
              component="img"
              src={TranparencyLogo}
              sx={{
                width: "min(10vh, 10vw)", // Ensures the logo is responsive
                height: "min(10vh, 10vw)",
                maxWidth: "15vh", // Prevents excessive scaling
                maxHeight: "15vh",
                "@media (max-width: 1080px) and (min-height: 1920px)": {
                  width: "min(10vh, 10vw)",
                  height: "min(10vh, 10vw)",
                },
                "@media (max-width: 900px) and (min-height: 1600px)": {
                  width: "min(4vh, 4vw)",
                  height: "min(4vh, 4vw)",
                },
              }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            mt: 4,
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "0.5rem", md: "0.7rem", xl: "1rem" },
              fontWeight: "bold",
              textAlign: "center",
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            }}
          >
            © DepEd Imus Division | 2023.
          </Typography>
        </Box>

        <PromptModal
          open={openModal}
          handleClose={() => setOpenModal(false)}
          prompt="Thank you! your response has been recorded"
        />
      </Box>
    </MainLayout>
  );
}

export default Feedback;
